// Internal modules
import { getGlobals } from '@/lib/globals';

const WEB = 'WEB';
const MAC_OS = 'Mac OS';

// On non-Mac OS machines the change event is fired when a keyboard
// user traverses through the select options. To prevent the country
// changing on every selection (CA -> ... -> US) we debounce the change.
export const shouldDebounceCountryChange = () => {
  const { channel, os } = getGlobals().device || {};

  // In the case when we don't have device information we'll default to
  // debouncing the change for everyone since not debouncing it is really
  // bad UX for keyboard users.
  if (!channel || !os) {
    return true;
  }

  return channel === WEB && os !== MAC_OS;
};
